import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { pageNameDict, SITE_INVENTORY_SERVICES, type SiteServiceName } from '@/constants';
import { resolveLocale } from '@/localization';

/**
 * The given services as one localized phrase, e.g. "Orbit One or Pen Viewer". Joined with
 * {@link Intl.ListFormat} so the separator and conjunction follow the active language, and so the
 * phrase keeps working as services are added instead of needing a translation key per combination.
 */
export const useSiteServiceListLabel = (services: readonly SiteServiceName[]): string => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return useMemo(
    () =>
      new Intl.ListFormat(resolveLocale(language), { type: 'disjunction' }).format(
        services.map(name => t(pageNameDict[SITE_INVENTORY_SERVICES[name].pageName]))
      ),
    [language, services, t]
  );
};
